/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faGlobeAmericas} from '@fortawesome/pro-duotone-svg-icons';

const StateReportingIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faGlobeAmericas} {...props} />
);

export default StateReportingIcon;
